var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_index",style:(_vm.rankStyle)},[_c('div',{staticClass:"page_main"},[_c('div',{staticClass:"page_title",class:_vm.customClass,style:(_vm.titleStyle)},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }